import React, { FC } from 'react';

import { t } from 'ttag';

import Icon from '../../../ui/icon/icon';

import FlexBox from '../../../FlexBox/FlexBox';

import NotificationIcon from '../images/notification.svg';

import css from './ResendCodeNotification.css';

interface ResendCodeNotificationProps {
    timer: number;
}

const ResendCodeNotification: FC<ResendCodeNotificationProps> = ({ timer }) => (
    <div className={css.container}>
        <FlexBox align="center" gap={12}>
            <div>
                <Icon
                    className={css.notificationIcon}
                    glyph={NotificationIcon}
                />
            </div>
            <div>
                <p
                    className={css.title}
                >{t`Повідомлення з кодом було надіслано повторно. `}</p>
                <p
                    className={css.description}
                >{t`Все рівно не отримали повідомлення? Зачекайте ${timer}с`}</p>
            </div>
        </FlexBox>
    </div>
);

export default ResendCodeNotification;
